var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.folder
    ? _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-folder")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("new-name"),
                          required: "",
                        },
                        model: {
                          value: _vm.newName,
                          callback: function ($$v) {
                            _vm.newName = $$v
                          },
                          expression: "newName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-user-search", {
                        attrs: {
                          users: _vm.notAddedUsers,
                          fancy: "",
                          label: _vm.$ct("to-add-user"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.addUser($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        _vm._l(_vm.sharedUsers, function (user) {
                          return _c(
                            "w-chip",
                            {
                              key: user.ID,
                              attrs: { closable: "" },
                              on: {
                                close: function ($event) {
                                  return _vm.removeUser(user)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(user.getUserString()) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c(
                        "w-link",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addAllUsers()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "mr",
                            attrs: { icon: "users" },
                          }),
                          _vm._v(" " + _vm._s(_vm.$ct("add-all-users")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.close")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }